import LeftArrow from 'assets/LeftArror';
import React, { FC } from 'react';
import { twMerge } from 'tailwind-merge';

import RenderIf from '@/components/Common/RenderIf';
interface Props {
  onClick?: React.MouseEventHandler<HTMLButtonElement> | undefined;
  show?: boolean;
  gradientClass?: string;
  className?: string;
  customNext?: React.MouseEventHandler<HTMLButtonElement> | undefined;
}
const Right: FC<Props> = ({
  onClick,
  show = true,
  gradientClass,
  className,
  customNext,
}) => {
  return (
    <div
      className={twMerge(
        ' absolute lg:-right-0 md:right-0 right-0 top-0 z-10 h-full lg:flex hidden items-center justify-center',
        className,
      )}
    >
      <button className='h-full relative' onClick={customNext || onClick} aria-label='Next'>
        <RenderIf condition={show}>
          <LeftArrow className=' z-10  transition-transform duration-300 ease-in-out cursor-pointer hover:scale-125' />
        </RenderIf>
        <div
          className={twMerge(
            'w-[250px] h-full  absolute top-0 -right-[50px] bg-gradient-to-l from-black/30 to-transparent -z-10',
            gradientClass,
          )}
        />
      </button>
    </div>
  );
};

export default Right;
